import { __decorate, __metadata } from "tslib";
import { IsBoolean } from 'class-validator';
export class MFARequirementsConfiguration {
    constructor(mfaEnforcement, mfaEnforcementSsoBypass, mfaEnforcementPublic, mfaEnforcementPublicSsoBypass) {
        this.mfaEnforcement = mfaEnforcement;
        this.mfaEnforcementSsoBypass = mfaEnforcementSsoBypass;
        this.mfaEnforcementPublic = mfaEnforcementPublic;
        this.mfaEnforcementPublicSsoBypass = mfaEnforcementPublicSsoBypass;
    }
}
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], MFARequirementsConfiguration.prototype, "mfaEnforcement", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], MFARequirementsConfiguration.prototype, "mfaEnforcementSsoBypass", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], MFARequirementsConfiguration.prototype, "mfaEnforcementPublic", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], MFARequirementsConfiguration.prototype, "mfaEnforcementPublicSsoBypass", void 0);
export const DEFAULT_MFA_REQUIREMENTS_CONFIGURATION = new MFARequirementsConfiguration(false, false, false, false);
